import React from 'react';

const PersonalInfoCard = ({ employee }) => {
  if (!employee) return null;

  return (
    <div className="bg-white shadow-md rounded-lg p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Personal Details Section */}
      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-4 border-b pb-2">Personal Information</h3>
        <div className="space-y-3 text-sm">
          <p><span className="font-medium text-gray-500">Gender:</span> <span className="text-gray-800 capitalize">{employee.gender}</span></p>
          <p><span className="font-medium text-gray-500">Date of Birth:</span> <span className="text-gray-800">{employee.date_of_birth}</span></p>
          <p><span className="font-medium text-gray-500">Blood Group:</span> <span className="text-gray-800">{employee.blood_group}</span></p>
          <p><span className="font-medium text-gray-500">Marital Status:</span> <span className="text-gray-800 capitalize">{employee.marital_status}</span></p>
          <p><span className="font-medium text-gray-500">Nationality:</span> <span className="text-gray-800">{employee.nationality}</span></p>
          
          {/* Languages Known Array Mapping */}
          <p>
            <span className="font-medium text-gray-500">Languages:</span>{' '}
            <span className="text-gray-800">
              {employee.languages_known?.join(', ') || 'N/A'}
            </span>
          </p>
        </div>
      </div>

      {/* Contact Details Section */}
      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-4 border-b pb-2">Contact Details</h3>
        <div className="space-y-3 text-sm">
          <p><span className="font-medium text-gray-500">Official Email:</span> <span className="text-gray-800">{employee.official_email}</span></p>
          <p><span className="font-medium text-gray-500">Personal Email:</span> <span className="text-gray-800">{employee.personal_email}</span></p>
          <p><span className="font-medium text-gray-500">Primary Phone:</span> <span className="text-gray-800">{employee.primary_phone}</span></p>
          
          {/* Newly Added Secondary Phone */}
          <p>
            <span className="font-medium text-gray-500">Secondary Phone:</span>{' '}
            <span className="text-gray-800">{employee.secondary_phone || 'N/A'}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfoCard;